import {
	linkScroll,
	animate,
	mobileMenu,
	header,
	credit,
	headerMenuDot,
	landingButtons,
	initSliders,
	modalButtons,
	phoneFields,
	handleFormSubmission,
	modalKill,
	initCarousels,
	handleBookOption,
	handleMenus,
	handleStripeForm,
	loadStripeForm,
	handleSignupModal,
} from './utils/helpers';

// Load classes
require('./components/carousel');
// require('./utils/payment');

// Load event helpers on DOM load
document.addEventListener('DOMContentLoaded', () => {
	landingButtons();
	modalButtons();
	modalKill();
	initCarousels();
	linkScroll();
	animate();
	phoneFields();
	mobileMenu();
	header();
	headerMenuDot();
	initSliders();
	handleMenus();
	loadStripeForm();
	handleFormSubmission();
	handleBookOption();
	handleSignupModal();
	credit();
});
